export enum StorageKey {
  Tokens = 'tokens',
  SummaryAccordionIndices = 'summary-accordion-indices',
}

export const ALLOWED_KEYS = Object.values(StorageKey);
